import { Component } from '@angular/core';
import { ClassTransformerHelper } from '../../../../helpers/class.transformer.helper';
import { WorkflowType } from '../../../../models/enums/workflowtype.enum';
import { KIDefinitionService } from '../../../../services/kidefinition.service';
import { WorkflowExitInfo, WorkflowModuleSettingsHelper, WorkflowRegistry } from '../../../../services/workflow.service';
import { FormulaWorkflowDialogContent } from '../../../workflow.dialog';

@Component({
    selector: 'wf-ocr-settings',
    templateUrl: './ocr.settings.html'
})
export class OcrSettings extends FormulaWorkflowDialogContent {
    Data = new OcrSettingsData();
    KIDefinitions: any[] = [];
    AvailableModels: string[] = [];
    MimeTypes = [
        { value: 'image/jpeg', label: 'image/jpeg' },
        { value: 'image/png', label: 'image/png' },
        { value: 'image/webp', label: 'image/webp' }
    ];

    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = 'ocrWFModule';
        reg.Caption = '@@KI: Text aus Bild extrahieren';
        reg.GroupID = 'aioperations';
        reg.Index = 104;
        reg.SettingsControl = OcrSettings;
        reg.SettingsTypeHelper = new OcrSettingsDataHelper();
        reg.WorkflowType = WorkflowType.Service;
        return reg;
    }

    constructor(private service: KIDefinitionService) {
        super();
    }

    ngOnInit() {
        this.service.GetKIDefinitions('Ocr').subscribe(list => {
            this.KIDefinitions = list || [];
            if (this.Data.KIDefinition) {
                this.loadModels(this.Data.KIDefinition);
            }
        });
    }

    initialize(data: any) {
        super.initialize(data);
        if (data) {
            this.Data = ClassTransformerHelper.CopyObject(data, OcrSettingsData);
        }
    }

    onKIDefinitionChange() {
        this.Data.Model = '';
        this.AvailableModels = [];
        if (this.Data.KIDefinition) {
            this.loadModels(this.Data.KIDefinition);
        }
    }

    private loadModels(id: string) {
        this.service.LoadKIDefinition(id).subscribe(def => {
            const all = def?.Models || [];
            const filtered = all.filter(m => (m.Capabilities & 16) !== 0);
            this.AvailableModels = (filtered.length > 0 ? filtered : all).map(m => m.Name);
        });
    }

    getResult() {
        return this.Data;
    }
}

export class OcrSettingsData {
    KIDefinition: string;
    Model: string = '';
    ImageMimeType: string = 'image/jpeg';
    Prompt: string = '';
    JsonSchema: string = '';
}

export class OcrSettingsDataHelper extends WorkflowModuleSettingsHelper {
    getExitPoints(settings: any): WorkflowExitInfo[] {
        return [new WorkflowExitInfo()];
    }
    getEmptySettingsInstance() {
        return new OcrSettingsData();
    }
}
